import { Pipe, PipeTransform } from '@angular/core';
import { CampaignType } from '@models/api-search.models';
import { ActiveCampaign } from '@features/product/product.models';
import { getCampaignByType } from '@features/campaigns/helper/get-campaign-by-type';

@Pipe({
    name: 'getCampaignType',
    standalone: true
})
export class GetCampaignTypePipe implements PipeTransform {
    transform(
        activeCampaigns: ActiveCampaign[] | undefined = [],
        campaignType: CampaignType
    ): ActiveCampaign | undefined {
        return getCampaignByType(activeCampaigns, campaignType);
    }
}
